import styled, { css } from 'styled-components';

export const InputWrapper = styled.div`
  width: 100%;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: 2px;
  box-shadow: none;
  padding: 2px;
  & svg {
    fill: ${({ theme }) => theme.grey};
  }
`;

export const CalendarWrapper = styled.div`
  ${({ theme }) => css`
    & .react-calendar {
      max-width: 100%;
      background-color: ${theme.popoverBackground};
      width: 240px;
      height: 255px;
      color: ${theme.color};
    }

    & .react-calendar--doubleView {
      width: 700px; 
      & .react-calendar__viewContainer {
        display: flex;
        margin: -0.5em;
        & > * {
          width: 50%;
          margin: 0.5em;
        }
      }
    }

    & .react-calendar,
    .react-calendar *,
    .react-calendar *:before,
    .react-calendar *:after {
      -moz-box-sizing: border-box;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    & .react-calendar button {
      margin: 0;
      border: 0;
      outline: none;
      padding: 0;
      &:enabled:hover {
        cursor: pointer;
      }
    }


    & .react-calendar__navigation {
      display: flex;
      height: 30px;
      & button {
        min-width: 30px;
        background: none;
        font-size: 20px;
        color: ${theme.color};
        &:disabled {
          color: ${theme.color}55;
          opacity: 0.3;
        }
        &.react-calendar__navigation__label {
          font-size: 14px;
          &:disabled {
            color: ${theme.color};
            opacity: 1;
          }
        }
      }
      & button:enabled:hover {
        background-color: ${theme.containerHover};
      }
    }

    & .react-calendar__month-view__weekdays {
      text-align: center;
      text-transform: uppercase;
      font: inherit;
      font-size: 11px;
      font-weight: bold;
      padding: 2px 0;
    }

    & .react-calendar__month-view__weekdays__weekday {
      padding: 0;
      font-size: 11px;
    }

    & .react-calendar__month-view__weekNumbers .react-calendar__tile {
      display: flex;
      align-items: center;
      justify-content: center;
      font: inherit;
      font-weight: bold;
    }

    & .react-calendar__year-view .react-calendar__tile,
    .react-calendar__decade-view .react-calendar__tile,
    .react-calendar__century-view .react-calendar__tile {
      padding: 0;
      aspect-ratio: 0;
      height: 56px;
    }

    & .react-calendar__tile {
      max-width: 100%;
      background: none;
      text-align: center;
      font: inherit;
      font-size: 13px;
      aspect-ratio: 1;
      color: ${theme.color};
      &:disabled {
        color: ${theme.color}55;
        opacity: 0.3;
      }
    }


    & .react-calendar__month-view__days__day--weekend {
      color: ${theme.error};
    }

    & .react-calendar__month-view__days__day--neighboringMonth,
    .react-calendar__decade-view__years__year--neighboringDecade,
    .react-calendar__century-view__decades__decade--neighboringCentury {
      color: ${theme.color}88;
    }

    & .react-calendar__month-view__days__day--neighboringMonth:disabled,
    .react-calendar__decade-view__years__year--neighboringDecade:disabled,
    .react-calendar__century-view__decades__decade--neighboringCentury:disabled {
      color: ${theme.color}55;
      opacity: 0.3;
    }

    & .react-calendar__tile:enabled:hover {
      background-color: ${theme.containerHover};
    }

    & .react-calendar__tile--now {
      color: ${theme.success};
    }

    & .react-calendar__tile--hasActive {
      background-color: ${theme.primary};
      color: ${theme.white};
    }

    & .react-calendar__tile--hasActive:enabled:hover {
      background-color: ${theme.primary}aa;
    }

    & .react-calendar__tile--active, .react-calendar__tile--selected {
      background-color: ${theme.primary};
      color: ${theme.white};
    }

    & .react-calendar__tile--active:enabled:hover, .react-calendar__tile--selected:enabled:hover {
      background-color: ${theme.primary}aa;
    }

    & .react-calendar--selectRange .react-calendar__tile--hover {
      background-color: ${theme.containerHover};
    }
  `}
`;
